import { GeotileActions } from '~/actions/'

const initialGeotileState = {
  name : null,
  id : '',
  editor : {
    imageLayerOpacity : 0.8,
    tileLayerOpacity : 1,
    drawMode : 'simple_select',
    keepAspect : true,
    currentFeature : null,
    currentZoom : 0
  }
};

function geotile( state = initialGeotileState, action ) {
  switch ( action.type ) {

    case GeotileActions.GET_GEOTILE: {
      const { geotile : nGeotile } = action
      const nState = { ...initialGeotileState, ...nGeotile }
      const { editor } = nState
      if ( nGeotile?.metadata?.feature && !editor.currentFeature ) {
        nState.editor = { ...editor, currentFeature : nGeotile.metadata.feature }
      }
      return nState
    }

    case GeotileActions.UPDATE_GEOTILE: {
      const { geotile : nGeotile } = action
      const nState = { ...state, ...nGeotile }
      const { editor } = nState
      if ( nGeotile?.metadata?.feature?.id && !editor.currentFeature ) {
        nState.editor = { ...editor, currentFeature : nGeotile.metadata.feature }
      }
      return nState
    }
    
    case GeotileActions.UPDATE_EDITOR:
      return { ...state, editor : { ...state.editor, ...action.editor } }

    default: 
      return state
  }
}

module.exports = geotile
